<template>
  <form :action="action" method="POST" target="_blank">
    <input v-for="field in fields" :key="field.name" type="hidden" :name="field.name" :value="field.value" />
    <c-button
      type="submit"
      :icon="{
        icon: 'google',
        color: 'green',
      }"
      label="Выгрузить в Google таблицы"
      responsive
    />
  </form>
</template>

<script>
import button from "@/components/controls/button";

export default {
  components: {
    "c-button": button,
  },
  data() {
    return {
      fields: [],
    };
  },
  computed: {
    action() {
      const { userId } = this.$store.state;
      return `/index.php?r=google-sheets/create&user_id=${userId}&table=documents`;
    },
  },
  methods: {
    update(params) {
      const fields = [];
      Object.entries(params.filters).forEach(([key, value]) => {
        if (typeof value === "object") {
          Object.entries(value).forEach(([key2, value2]) => {
            const name = `filters[${key}][${key2}]`;
            const value = value2;
            fields.push({
              name,
              value,
            });
          });
        } else {
          fields.push({
            name: `filters[${key}]`,
            value,
          });
        }
      });
      this.fields = fields;
    },
  },
};
</script>
